export const DATA_HOOK = {
  TimeInputInput: 'TimeInput-input',
  TimeInputDropdown: 'TimeInput-dropdown',
};

export const ACTION = {
  RESET: 'RESET',
  SET_STATE: 'SET_STATE',
  SET_ERROR: 'SET_ERROR',
  OPEN_DROPDOWN: 'OPEN_DROPDOWN',
  CLOSE_DROPDOWN: 'CLOSE_DROPDOWN',
  DELETE_EVENT: 'DELETE_EVENT',
};

export const _24HOUR_TIME_FORMATS = [
  'en-GB',
  'bg',
  'ca',
  'zh',
  'cs',
  'da',
  'nl',
  'fi',
  'fr',
  'fr-CA',
  'fr-CH',
  'fr-BE',
  'de',
  'de-CH',
  'de-AT',
  'he',
  'ja',
  'lt',
  'hu',
  'id',
  'it',
  'nb',
  'nn',
  'pl',
  'pt-BR',
  'pt',
  'ro',
  'ru',
  'sk',
  'sl',
  'es',
  'es-419',
  'es-AR',
  'es-MX',
  'sv',
  'th',
  'uk',
  'vi',
];

export const _12HOUR_TIME_FORMATS = [
  'en',
  'en-US',
  'en-AU',
  'en-CA',
  'ar',
  'zh-TW',
  'zh-HK',
  'zh-MO',
  'el',
  'hi',
  'ko',
  'ms',
  'es-US',
  'tl',
  'tr',
];
